import { LabelValuePair } from '../../job/jobDetail/types/LabelValuePair';

export const INCLUDE_LOGO = 'Shamrock';
export const EXCLUDE_LOGO = 'Plain';

export const PRINT_OPTIONS: Array<LabelValuePair> = [
  { label: INCLUDE_LOGO, value: INCLUDE_LOGO },
  { label: EXCLUDE_LOGO, value: EXCLUDE_LOGO },
];
